import { createFileRoute } from '@tanstack/react-router'

import { AuditLogsPage } from '@/pages/audit-logs'

export const Route = createFileRoute('/_app/audit-logs')({
  component: RouteComponent,
})

export const AuditLogsRoute = Route

function RouteComponent() {
  return <AuditLogsPage />
}
